export * from './page-metadata.component';
export * from './page-metadata.types';
